import { Link } from 'react-router-dom';

export interface PublicLandingHeaderProps {
  /** "Portail École" / "Espace Parent" — affiché après "Mon Ecolier /". */
  portalLabel: string;
}

/**
 * UX-59 — en-tête PARTAGÉ entre les accueils /office et /parent à l'état NON
 * CONNECTÉ (Étape 0 : header/hero identiques dans les deux specs Claude
 * Design — même fond teal, même paire de CTA Se connecter/Créer un compte,
 * mêmes routes locales `/login`/`/register` dans les deux apps). Le HERO
 * (contenu sous le header) reste en revanche PAGE-LOCAL : trop spécifique à
 * chaque portail (KPIs mockés côté école, cartes éditoriales côté parent)
 * pour justifier une seconde abstraction partagée.
 */
export function PublicLandingHeader({ portalLabel }: PublicLandingHeaderProps) {
  return (
    <header
      className="flex w-full flex-wrap items-center justify-between gap-4 rounded-t-xl bg-brand-600 px-6 py-4"
      data-testid="public-landing-header"
    >
      <span className="text-base font-semibold text-white">
        Mon Ecolier <span className="font-normal text-brand-100">/ {portalLabel}</span>
      </span>
      <div className="flex items-center gap-3">
        <Link
          to="/login"
          className="rounded-md px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
        >
          Se connecter
        </Link>
        <Link
          to="/register"
          className="rounded-md bg-white px-3 py-1.5 text-sm font-medium text-brand-700 shadow-sm transition-colors hover:bg-brand-50"
        >
          Créer un compte
        </Link>
      </div>
    </header>
  );
}
